module.exports = __webpack_public_path__ + "img/header-engagementRingsRingsets@2x.450dc18.webp";